module.exports = __webpack_public_path__ + "static/media/pie_no_data.0733b205.svg";